export class PopoverDataModel {
    constructor (props) {
        const {
            label, // [String]
            id, // [String, Number]
            handle, // [String] // Don't present on variants and customObjects
            description, // [String] Present only on: customObjects
        } = props

        this.label = label
        this.id = id
        this.handle = handle
        this.description = description
    }
}


// WEBPACK FOOTER //
// ./src/models/popover-data.model.js